export enum OnlineReportType {
  User = 'user',
  Admin = 'admin',
  ReviewAdmin = 'review-admin',
  AdminAssociation = 'admin-associations',
  Association = 'business-portal',
  ReviewAdminAssociation = 'review-admin-associations',
}
